import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';
import promiseMiddleware from './../middleware/promise-middleware';
import { persistConfig, Reducer } from './../reducers/index';
import { utility } from './../utils';
import constants from './../config/constants';
const persistedReducer = persistReducer(persistConfig, Reducer);
function configuredStore() {
    const _store = configureStore({
        reducer: persistedReducer,
        middleware: _getMiddleware()
    });
    _enableHotLoader(_store);
    return _store;
}
function _getMiddleware() {
    let middleware = [
        promiseMiddleware,
        thunk
    ];
    if (__DEV__) {
        const { createLogger } = require('redux-logger');
        const reduxLogger = createLogger({
            collapsed: true,
            stateTransformer: (state) => state,
        });
        middleware = [...middleware, reduxLogger];
    }
    return middleware;
}
function _enableHotLoader(_store) {
    if (!__DEV__) {
        return;
    }
    const { hot } = module;
    if (hot) {
        hot.accept('./../reducers', () => {
            const nextRootReducer = require('./../reducers');
            _store.replaceReducer(nextRootReducer);
        });
    }
}
export const store = configuredStore();
export const persistor = persistStore(store);
let hasWarnedLowOfflineStorage = false;
let lastPersistedStateRefs = {};
store.subscribe(function () {
    const state = store.getState();
    const persistedRefsChanged = persistConfig.whitelist.some((key) => state[key] !== lastPersistedStateRefs[key]);
    if (!persistedRefsChanged) {
        return;
    }
    try {
        const persistedState = persistConfig.whitelist.reduce((acc, key) => {
            acc[key] = state[key];
            return acc;
        }, {});
        lastPersistedStateRefs = persistedState;
        const persistedStorageSizeMB = JSON.stringify(persistedState).length / 1000000;
        if (persistedStorageSizeMB > 4) {
            if (!hasWarnedLowOfflineStorage) {
                hasWarnedLowOfflineStorage = true;
                utility.alert('Low offline storage space. Please go online to free space.', constants.TOAST_TYPES.WARN);
            }
        }
        else {
            hasWarnedLowOfflineStorage = false;
        }
    }
    catch (e) {
        if (!hasWarnedLowOfflineStorage) {
            hasWarnedLowOfflineStorage = true;
            utility.alert('Very low offline storage space. Please go online to free space.', constants.TOAST_TYPES.WARN);
        }
    }
});
